import { Component } from '@angular/core';

@Component({
    selector: 'app-not-linked-to-account-window',
    templateUrl: './not-linked-to-account-window.component.html',
    styleUrls: ['./not-linked-to-account-window.component.scss'],
    standalone: false
})
export class NotLinkedToAccountWindowComponent {
}
